const state = {
	aId:'',
	typeCode:''
};
const mutations = {
	SetAId: (state: any, value: any)=>{
		state.aId = value;
	},
	SetTypeCode: (state: any, value: any) => {
		state.typeCode = value;
	}
};

const actions = {

};
const getters = {

};
export default {
	state,
	actions,
	mutations,
	getters
};
